import { render } from "./basicDialog.vue?vue&type=template&id=6dd66410&scoped=true"
import script from "./basicDialog.vue?vue&type=script&lang=js"
export * from "./basicDialog.vue?vue&type=script&lang=js"

import "./basicDialog.vue?vue&type=style&index=0&id=6dd66410&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd66410"]])

export default __exports__